<template>
    <div :class="numberClasses" :style="style" v-if="value!==null" ref="number">
        {{currentValue}}
    </div>
</template>

<script>

    import { gsap } from "gsap";

    export default {

        components: {},

        props: {

            value: {
                type: Number | String,
                required: true,
            },

            size: {
                type: String,
                required: false,
                validator: value => {
                    return ['small', 'medium', 'large'].includes(value);
                },
                default: 'large',
            },

            color: {
                type: String,
                required: false,
                default: "#666"
            },

            noSkip: {
                type: Boolean,
                required: false,
                default: false,
            },

            highlightColor: {
                type: String,
                required: false,
                default: 'transparent'
            }
        },

        watch: {
            value(newValue) {
                this.tween(newValue);
            },
        },

        computed: {

            style() {
                return "border-bottom: 8px solid " + this.highlightColor +"; background-color: " + this.color + ";";
            },

            isDelimeter() {
                return ['.', ','].includes(this.value);
            },

            isLetter() {
                if (typeof this.value !== 'string') {
                    return false;
                }
                const asciiCode = this.value.toString().charCodeAt(0);
                if (asciiCode >= 97 && asciiCode <= 122) return true;
                if (asciiCode >= 65 && asciiCode <= 90) return true;

                return ['%', '$', '€', '£'].includes(this.value);
            },

            numberClasses() {
                let classes = [];

                if (this.isDelimeter) {
                    classes = this.configNumber[this.size].classes;
                    classes.push('delimeter');
                    classes.push('pa-0');
                } else if (this.isLetter) {
                    classes = this.configLetter[this.size].classes;
                    classes.push('letter');
                    classes.push('pa-0');
                } else {
                    classes = this.configNumber[this.size].classes;
                    classes.push('elevation-2');
                    classes.push('pa-1');
                }

                return classes.join(' ');
            }
        },

        data() {
            return {
                currentValue: this.value,
                animationCompleted: true,
                configNumber: {
                    small: {
                        classes: ['smallNumberBox', 'display-2'],
                    },
                    medium: {
                        classes: ['mediumNumberBox'],
                    },
                    large: {
                        classes: ['largeNumberBox', 'display-4']
                    }
                },
                configLetter: {
                    small: {
                        classes: ['smallNumberBox', 'display-1'],
                    },
                    medium: {
                        classes: ['mediumNumberBox'],
                    },
                    large: {
                        classes: ['largeNumberBox', 'display-3']
                    }
                }
            }
        },

        mounted() {
            this.tween(this.value);
        },

        methods: {
            randomNumber(min, max) {
                return Math.floor(Math.random() * (+max - +min)) + +min;
            },
            tween(newValue) {

                if (this.animationCompleted) {

                    if (this.noSkip === false) this.animationCompleted = false;

                    gsap.to(this.$refs.number, 0.12, {
                        rotationX: 90,
                        y: 0,
                        scaleX: 1,
                        //color: 'grey',
                        //ease: Expo.easeOut
                    }).eventCallback('onComplete', () => {
                        this.currentValue = newValue;
                        gsap.to(this.$refs.number, 0.12, {
                            rotationX: 0,
                            rotation: this.randomNumber(-2, 2),
                            y: 0,
                            scaleX: 1,
                            //color: 'white',
                            //ease: Expo.easeIn
                        }).eventCallback('onComplete', () => {
                            this.animationCompleted = true;
                        });
                    });
                }
            }
        }
    }
</script>

<style scoped>

    .largeNumberBox {
        display: inline-block;
        width: 80px;
        height: 105px;
        text-align: center;
        color: #eee;
        margin-right: 5px;
        border-radius: 5px;
    }

    .mediumNumberBox {
        display: inline-block;
        width: 60px;
        height: 90px;
        text-align: center;
        color: #eee;
        margin-right: 5px;
        border-radius: 5px;
        font-family: Roboto, sans-serif;
        font-size: 85px;
        line-height: 85px;
        font-weight: 300;
    }

    .smallNumberBox {
        display: inline-block;
        width: 40px;
        height: 60px;
        text-align: center;
        color: #eee;
        margin-right: 5px;
        border-radius: 5px;
    }

    .delimeter {
        display: inline-block;
        width: 10px;
        height: 55px;
        text-align: center;
        background-color: transparent;
        color: #eee;
        margin-right: 5px;
        border-radius: 5px;
    }

    .letter {
        display: inline-block;
        width: 30px;
        height: 45px;
        text-align: center;
        background-color: transparent;
        color: #eee;
        margin-right: 5px;
        border-radius: 5px;
    }

</style>
